import { ImageLoaderConfig } from '@angular/common';

import { MaxWidthLargeScreenCDN, MediaWidthMultiplier } from '../models/media.models';

import { amandaProcessUrl } from './amanda.service';

// #region PRIVATE
function getCustomWidth(width: number): string {
    return (width * MediaWidthMultiplier).toString();
}

function shouldApplyCDNParams(width: number): boolean {
    return !!width && width < MaxWidthLargeScreenCDN;
}

function generateUrlParams(config: ImageLoaderConfig): string {
    const url = new URL(config.src);
    url.searchParams.set('imwidth', getCustomWidth(config.width));
    url.searchParams.set('imformat', config.loaderParams.imageFormat);
    return url.toString();
}

function hasTimestampParam(param: string): boolean {
    return param === 't' || param === 'ts' || param === 'timestamp';
}

function cleanUrlFromParameters(url: string): string {
    const newUrl = new URL(url.toString());
    const searchParams = new URLSearchParams(newUrl.search);
    const newSearchParams = new URLSearchParams();

    searchParams.forEach((value, key) => {
        if (key && hasTimestampParam(key)) {
            newSearchParams.append(key, value);
        }
    });

    newUrl.search = newSearchParams.toString();
    return newUrl.toString();
}
// # endregion

export function imageOptimizeLoader(config: ImageLoaderConfig): string {
    if (shouldApplyCDNParams(config?.width)) {
        // CDN AMANDA
        if (config.loaderParams.hasAmandaSrc) {
            return amandaProcessUrl(config.src, config.width?.toString());
        }
        return generateUrlParams(config);
    }

    // La primera imagen del src-set de la directiva image optimize angular no tiene params
    // Para pantallas superiores a 2500 y con densidades superiores a 1x si ocupan + del 90% de la pantalla -> servimos imagen sin CDN
    return config?.src ? cleanUrlFromParameters(config.src) : null;
}
